import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
// React-bootstrap
import Container from "react-bootstrap/Container"
// styles
import "bootstrap/dist/css/bootstrap.min.css"
import "./styles/App.css"
// components
import ArticlePage from "./components/ArticlePage"
import UserManagement from "./components/UserManagement"
import MainPageBody from "./components/MainPageBody"
import Login from "./components/Login"
import Footer from "./components/Footer"
import { Routes, Route } from "react-router-dom"
import loginService from "./services/loginService"
import MainNavbar from "./components/MainNavbar"
import ArticleForm from "./components/ArticleForm"
import AboutUs from "./components/AboutUs"
// services
// import articleService from "./services/articleService"
import eventService from "./services/eventService"
import newsService from "./services/newsService"
import Rules from "./components/Rules"
import Feedback from "./components/Feedback"
import EventsList from "./components/EventsList"

function App() {
  const { t, i18n } = useTranslation()
  const [events, setEvents] = useState([])
  const [upcomingEvents, setUpcomingEvents] = useState([])
  const [gameNights, setGameNights] = useState([])
  const [loading, setLoading] = useState(null)
  const [news, setNews] = useState([])
  const [currentUser, setCurrentUser] = useState(null)


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng, () => {
    }).then(() => {
      // language can be string literal "en" or "fi"
      localStorage.setItem("breikkiLang", lng)
    }).catch((err) => {
      console.log("Error loading translations!", err)
    })
  }

  const getCredentials = () => {
    loginService.getCredentials()
      .then((ret) => {
        setCurrentUser(ret && ret.user ? ret.user : ret)
      }).catch(err => {return})
  }

  // // load articles
  // useEffect(() => {
  //   articleService.getAllArticles()
  //     .then((allarts) => {
  //       if (allarts) {
  //         setArticles(allarts)
  //       } else {
  //         console.log("Loading articles failed", allarts)
  //       }
  //     }).catch(err => console.error(err))
  // }, [])


  const getEvents = async () => {
    try {
      setLoading(true)
      const allEvents = await eventService.getAllEvents()
      if (allEvents) {
        setEvents(allEvents)
      } else {
        console.error("Loading all events failed", allEvents)
      }
      
      const upcomingEvents = await eventService.getUpcomingEvents("EVENT_TYPE_UNSPECIFIED", 1, 3)
      if (upcomingEvents) {
        setUpcomingEvents(upcomingEvents)
      } else {
        console.error("Loading upcoming events failed", upcomingEvents)
      }
      
      const gameNights = await eventService.getUpcomingEvents("GAME_NIGHT", 1, 3)
      if (gameNights) {
        setGameNights(gameNights)
      } else {
        console.error("Loading all events failed", gameNights)
      }
      setLoading(false)


    } catch (err) {
      console.error(err)
    }
  }

  const getNews = async () => {
    try {
      const allNews = await newsService.getAllNews()
      if (allNews) {
        setNews(allNews)
      } else {
        console.error("Loading events failed", allNews)
      }

    } catch (err) {
      console.error(err)
    }
  }

  // load events
  useEffect(() => {
    getEvents()
  }, [])
  // load news
  useEffect(() => {
    getNews()
  }, [])

  useEffect(() => getCredentials(), [])

  const isAdmin = () => {
    return currentUser && (currentUser.role === "admin" || currentUser.role === "superuser")
  }
  const isSuperuser = () => {
    return currentUser && currentUser.role === "superuser"
  }

  return (
    <div className="App">
      <MainNavbar changeLanguage={changeLanguage} currentUser={currentUser} setCurrentUser={setCurrentUser} isAdmin={isAdmin()} isSuperuser={isSuperuser()} />
      <Container fluid style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<MainPageBody upcomingEvents={upcomingEvents} news={news} gameNights={gameNights} loading={loading} />} />
          <Route path="/login" element={<Login currentUser={currentUser} setCurrentUser={setCurrentUser} />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/rules" element={<Rules />} />
          {events && events.length !== 0 && <Route path="/events" element={<EventsList />} />}
          {events && events.length !== 0 ? (events.map((e) => <Route path={`/event/${e._id}`} key={e._id} element={<ArticlePage eventId={e._id} isAdmin={isAdmin()} />} />)) : <></>}
          {news && news.length !== 0 && (news.map((n) => <Route path={`/news/${n._id}`} key={n._id} element={<ArticlePage newsId={n._id} isAdmin={isAdmin()} />} />))}
          {isAdmin(currentUser) && (
            <>
              <Route path="/create-article" element={<ArticleForm editMode={false} />} />
              <Route path="/user-management" element={<UserManagement currentUser={currentUser} setCurrentUser={setCurrentUser} />} /> 
            </>
          )}
        </Routes>
      </Container>
      <Footer />
    </div>


  )
}

export default App
